import type { Account } from "bonusx-api-main-manager";
import type { ServiceType } from "../../../../legacy/services/ApiClientBonusXServiceRepository/types/ServiceType.type";
import type { GTM } from "../../../../legacy/services/gtmEvent/GTMInterfaces";
import type { UserSubscription } from "../../../../legacy/services/user-subscription/entities/user-subscription.entity";
import { SubscriptionCheckoutQueryString } from "../entities/subscription-checkout-query-string.enum";
import { sendGtmEventWhenSubscriptionIsUpdated } from "./payment-backdrop-event";

export function sendGtmEventAfterUpgrade(
  this: null,
  accountData: Account,
  url: URL,
  subscription: UserSubscription
): void {
  const defaultValue = 0;
  const amountDivider = 100;
  const amountPaid = (subscription.amountPaid ?? subscription.amount ?? defaultValue) / amountDivider;
  const transactionId = url.searchParams.get(SubscriptionCheckoutQueryString.ID);
  if (!transactionId) {
    throw new Error("Transaction id not found");
  }

  const items: GTM.ServiceExtended[] = [
    {
      unique_identifier: subscription.providerCode,
      currency: "EUR",
      discount: {
        code: "",
        amount: 0,
      },
      price: amountPaid,
      quantity: 1,
      id: 0,
      available: false,
      target: "personal",
      type: "subscription" as ServiceType,
      necessaryData: [],
      name: "",
      imageUrl: "",
      freeBlock: "",
      description: subscription.providerCode,
      category: 0,
      beneficiaries: "",
      advantages: "",
      duration: "",
      requisites: "",
      messageFinalized: "",
      requiredDocumentsText: "",
      issue: "",
      shortDescription: "",
      itemsAvailablePerOrder: 0,
      applicant: 0,
      family: 0,
      member: 0,
      applicantDocuments: [],
      familyDocuments: [],
      familyMemberDocuments: [],
      additionalQuestionnaireName: "",
      requisitesQuestionnaireName: "",
      requisitesSurveyName: null,
      familyMemberFieldName: "",
      functionNameService: "",
      publicationDate: "",
      order: 0,
      created_at: new Date(),
      updated_at: new Date(),
      isVisible: true,
      isRequestable: true,
      requestableFromTier: "",
      activeProcedureIdsByDescCreationOrder: [],
    },
  ];

  sendGtmEventWhenSubscriptionIsUpdated({ accountData, amountPaid, transactionId, items });
}
